import Marquee from "react-fast-marquee";

const items = [
  "META MARKETING API",
  "FACEBOOK ADS",
  "INSTAGRAM",
  "GOOGLE SEARCH ADS",
  "LEAD FORMS",
  "CLAUDE AI",
  "GEMINI IMAGES",
  "AD PREVIEWS",
  "BRAND KIT",
];

export default function MarqueeStrip() {
  return (
    <div className="mt-24 border-y border-neutral-200 bg-white py-5" data-testid="marquee-strip">
      <Marquee speed={30} gradient gradientColor="#ffffff" gradientWidth={80} autoFill>
        {items.map((item) => (
          <span key={item} className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-500 mx-6 flex items-center gap-6">
            {item} <span className="text-[#FF4D00]">·</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
